import { create } from 'zustand';

import { ReportOrgan } from '@/api';

import { OrganName, ReportOrganState } from './use-report-organ.model';

export const useReportOrganStore = create<ReportOrganState>((set, get) => ({
  getReportOrgan: (reportUuid, organName) => get().reportOrgans[reportUuid]?.[organName],
  reportOrgans: {},
  setReportOrgan: (reportUuid, organName, reportOrgan) => {
    set((state) => ({
      reportOrgans: {
        ...state.reportOrgans,
        [reportUuid]: {
          ...state.reportOrgans[reportUuid],
          [organName]: reportOrgan,
        },
      },
    }));
  },
  setReportOrgans: (reportUuid, reportOrgans: ReportOrgan[]) => {
    set((state) => {
      const existingOrgans = state.reportOrgans[reportUuid] ?? {};

      return {
        reportOrgans: {
          ...state.reportOrgans,
          [reportUuid]: reportOrgans.reduce(
            (acc, organ) => {
              acc[organ.organ] = organ;

              return acc;
            },
            { ...existingOrgans } as Record<OrganName, ReportOrgan>,
          ),
        },
      };
    });
  },
}));
